import { ReactNode } from 'react';

import { useDroppable } from '@dnd-kit/core';

export type DroppableRunProps = {
  runId: string;
  isInvalid: boolean;
  isDragSource: boolean;
  children: ReactNode;
  dataTour?: string;
  isSelected?: boolean;
  onClick?: () => void;
  speciesSubfamily?: string;
};

const getSpeciesStripeClass = (species?: string): string => {
  if (species === 'Ovine') return 'bg-orange-500';
  if (species === 'Caprine') return 'bg-green-500';
  return '';
};

export const DroppableRun = ({
  runId,
  isInvalid,
  isDragSource,
  children,
  dataTour,
  isSelected,
  onClick,
  speciesSubfamily,
}: DroppableRunProps) => {
  const { setNodeRef, isOver } = useDroppable({
    id: runId,
  });

  const stripeClass = getSpeciesStripeClass(speciesSubfamily);

  return (
    <div
      ref={setNodeRef}
      data-tour={dataTour}
      onClick={onClick}
      className={`relative flex cursor-pointer flex-col rounded-lg border-2 bg-white p-4 ${stripeClass ? 'pl-6' : ''} transition-all ${
        isInvalid
          ? 'border-red-300 bg-red-50'
          : isOver
            ? 'border-blue-500 bg-blue-50 shadow-lg'
            : isDragSource
              ? 'border-gray-300 opacity-75'
              : isSelected
                ? 'border-blue-400 ring-2 ring-blue-200'
                : 'border-gray-200'
      }`}
    >
      {stripeClass && (
        <div
          className={`absolute top-0 bottom-0 left-0 w-2 rounded-l-lg ${stripeClass}`}
        />
      )}
      {children}
    </div>
  );
};
